<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">

      <el-form-item label="分類">
        <el-select v-model="form.GroupID" placeholder="選擇分類">
          <el-option v-for="group in $store.state.qaGroup.list" :key="`group-${group.ID}-in-qa-editor-modal`" :label="group.TitleTw" :value="group.ID"/>
        </el-select>
      </el-form-item>

      <el-form-item label="問題(繁中)">
        <el-input v-model="form.QuestionTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="問題(簡中)">
        <el-input v-model="form.QuestionCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="問題(英文)">
        <el-input v-model="form.QuestionEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="問題(日文)">
        <el-input v-model="form.QuestionJp"></el-input>
      </el-form-item>

      <el-form-item label="回答(繁中)">
        <el-input type="textarea" v-model="form.AnswerTw"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Cn')" label="回答(簡中)">
        <el-input type="textarea" v-model="form.AnswerCn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('En')" label="回答(英文)">
        <el-input type="textarea" v-model="form.AnswerEn"></el-input>
      </el-form-item>
      <el-form-item v-show="languages.includes('Jp')" label="回答(日文)">
        <el-input type="textarea" v-model="form.AnswerJp"></el-input>
      </el-form-item>
      <el-form-item label="權重">
        <el-input v-model="form.Weigh" type="number"></el-input>
      </el-form-item>
      <el-form-item label="置頂">
        <el-switch
          v-model="form.IsTop"
          class="switch-deploy"
          active-text="是"
          inactive-text="否"
          inactive-color="red"
        ></el-switch>
      </el-form-item>
      <el-form-item label="狀態">
        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        QuestionTw: '',
        QuestionCn: '',
        QuestionEn: '',
        QuestionJp: '',
        Weigh: 0,
        IsActive: true,
        IsTop: false
      },
      mIsShow: false,
      isLoading: false
    }
  },
  computed: {
    isEdit () {
      return this.oriObj !== null
    },
    title () {
      return this.isEdit ? this.oriObj.QuestionTw : '新增QA'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Weigh = parseInt(this.form.Weigh)
      let promise = this.isEdit
        ? this.$services.qa.edit(this, this.form)
        : this.$services.qa.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Weight: 0, IsActive: true }
      this.$emit('submitted', res.data.result)
      this.close()
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.qa.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.qa.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.qa.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown qa for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      if (!this.form.QuestionTw) {
        errMsg = '請輸入繁中問題'
      }
      if (this.languages.includes('Cn') && !this.form.QuestionCn) {
        errMsg = '請輸入簡中問題'
      }
      if (this.languages.includes('En') && !this.form.QuestionEn) {
        errMsg = '請輸入英文問題'
      }
      if (this.languages.includes('Jp') && !this.form.QuestionJp) {
        errMsg = '請輸入日文問題'
      }

      if (!this.form.AnswerTw) {
        errMsg = '請輸入繁中答覆'
      }
      if (this.languages.includes('Cn') && !this.form.AnswerCn) {
        errMsg = '請輸入簡中答覆'
      }
      if (this.languages.includes('En') && !this.form.AnswerEn) {
        errMsg = '請輸入英文答覆'
      }
      if (this.languages.includes('Jp') && !this.form.AnswerJp) {
        errMsg = '請輸入日文答覆'
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          this.form = JSON.parse(JSON.stringify(this.oriObj))
        } else {
          this.form = {
            Weigh: 0,
            IsActive: true
          }
        }
      }
    }
  }
}
</script>
